(function(){
  var root=document.getElementById("wl-dog");
  if(!root||root.dataset.ready==="true")return;
  root.dataset.ready="true";

  var PROFILE_KEY="waglife_dog_profiles";
  var SELECTED_KEY="waglife_selected_dog_id";
  var form=document.getElementById("wl-dog-form");
  var strip=document.getElementById("wl-profile-strip");
  var photoInput=document.getElementById("wl-photo");
  var photoPreview=document.getElementById("wl-photo-preview");
  var currentPhoto=document.getElementById("wl-current-photo");
  var currentName=document.getElementById("wl-current-name");
  var currentMeta=document.getElementById("wl-current-meta");
  var toast=document.getElementById("wl-toast");
  var tabs=[].slice.call(root.querySelectorAll("[data-tab]"));
  var panels=[].slice.call(root.querySelectorAll("[data-panel]"));
  var order=["identity","personality","health","baseline","care"];
  var profiles=read(PROFILE_KEY);
  var selectedId=localStorage.getItem(SELECTED_KEY)||"";
  var activeTab="identity";
  var imageData="";
  var toastTimer;

  function read(key){
    try{
      var data=JSON.parse(localStorage.getItem(key)||"[]");
      return Array.isArray(data)?data:[];
    }catch(e){return[]}
  }

  function saveAll(){
    localStorage.setItem(PROFILE_KEY,JSON.stringify(profiles));
  }

  function makeId(){
    return "dog_"+Date.now()+"_"+Math.random().toString(36).slice(2,8);
  }

  function esc(v){
    return String(v||"").replace(/&/g,"&amp;").replace(/</g,"&lt;")
      .replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#039;");
  }

  function notify(message){
    toast.textContent=message;
    toast.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer=setTimeout(function(){toast.classList.remove("is-visible")},2300);
  }

  function selected(){
    return profiles.find(function(p){return p.id===selectedId})||null;
  }

  function val(id){
    var el=document.getElementById(id);
    return el?el.value.trim():"";
  }

  function setVal(id,v){
    var el=document.getElementById(id);
    if(el)el.value=v||"";
  }

  function checked(name){
    return [].slice.call(form.querySelectorAll('input[name="'+name+'"]:checked'))
      .map(function(el){return el.value});
  }

  function setChecked(name,values){
    values=Array.isArray(values)?values:[];
    form.querySelectorAll('input[name="'+name+'"]').forEach(function(el){
      el.checked=values.indexOf(el.value)!==-1;
    });
  }

  function collect(){
    var old=selected();
    return{
      id:old?old.id:(selectedId||makeId()),
      createdAt:old?old.createdAt:new Date().toISOString(),
      updatedAt:new Date().toISOString(),
      photo:imageData,
      name:val("wl-name"),breed:val("wl-breed"),birthday:val("wl-birthday"),
      age:val("wl-age"),sex:val("wl-sex"),weight:val("wl-weight"),
      size:val("wl-size"),coat:val("wl-coat"),energy:val("wl-energy"),
      social:val("wl-social"),crowds:val("wl-crowds"),weather:val("wl-weather"),
      activities:checked("activities"),personalityNotes:val("wl-personality-notes"),
      fixed:val("wl-fixed"),mobility:val("wl-mobility"),
      sensitivities:checked("sensitivities"),healthNotes:val("wl-health-notes"),
      resting:val("wl-resting"),breathing:val("wl-breathing"),
      appetite:val("wl-appetite"),vocal:val("wl-vocal"),walk:val("wl-walk"),
      recovery:val("wl-recovery"),changeNotes:val("wl-change-notes"),
      vetName:val("wl-vet-name"),vetPhone:val("wl-vet-phone"),
      emergencyName:val("wl-emergency-name"),emergencyPhone:val("wl-emergency-phone"),
      microchip:val("wl-microchip"),insurance:val("wl-insurance"),
      emergencyNotes:val("wl-emergency-notes")
    };
  }

  function fill(p){
    form.reset();
    imageData=p&&p.photo?p.photo:"";
    [
      ["wl-name","name"],["wl-breed","breed"],["wl-birthday","birthday"],
      ["wl-age","age"],["wl-sex","sex"],["wl-weight","weight"],["wl-size","size"],
      ["wl-coat","coat"],["wl-energy","energy"],["wl-social","social"],
      ["wl-crowds","crowds"],["wl-weather","weather"],
      ["wl-personality-notes","personalityNotes"],["wl-fixed","fixed"],
      ["wl-mobility","mobility"],["wl-health-notes","healthNotes"],
      ["wl-resting","resting"],["wl-breathing","breathing"],
      ["wl-appetite","appetite"],["wl-vocal","vocal"],["wl-walk","walk"],
      ["wl-recovery","recovery"],["wl-change-notes","changeNotes"],
      ["wl-vet-name","vetName"],["wl-vet-phone","vetPhone"],
      ["wl-emergency-name","emergencyName"],["wl-emergency-phone","emergencyPhone"],
      ["wl-microchip","microchip"],["wl-insurance","insurance"],
      ["wl-emergency-notes","emergencyNotes"]
    ].forEach(function(pair){setVal(pair[0],p&&p[pair[1]])});
    setChecked("activities",p&&p.activities);
    setChecked("sensitivities",p&&p.sensitivities);
    renderPhoto();
  }

  function renderPhoto(){
    var bg=imageData?"url('"+imageData+"')":"";
    photoPreview.style.backgroundImage=bg;
    currentPhoto.style.backgroundImage=bg;
    photoPreview.innerHTML=imageData?"":"🐾";
    currentPhoto.innerHTML=imageData?"":"🐾";
  }

  function renderSummary(){
    var p=selected();
    if(!p){
      currentName.textContent="Add your first dog";
      currentMeta.textContent="Create a profile to begin";
      imageData="";
      renderPhoto();
      return;
    }
    currentName.textContent=p.name||"Unnamed Dog";
    currentMeta.textContent=[p.breed,p.age||p.size].filter(Boolean).join(" · ")||"Profile in progress";
    imageData=p.photo||"";
    renderPhoto();
  }

  function renderStrip(){
    strip.innerHTML=profiles.map(function(p){
      var style=p.photo?' style="background-image:url(\''+esc(p.photo)+'\')"':"";
      return '<button type="button" class="wl-pill'+(p.id===selectedId?" is-active":"")+
        '" data-profile-id="'+esc(p.id)+'"><span class="wl-pill-photo"'+style+'>'+
        (p.photo?"":"🐾")+'</span><span><strong>'+esc(p.name||"Unnamed Dog")+
        '</strong><span>'+esc(p.breed||p.size||"Profile in progress")+
        '</span></span></button>';
    }).join("");
  }

  function selectProfile(id){
    selectedId=id;
    localStorage.setItem(SELECTED_KEY,id);
    fill(selected());
    renderStrip();
    renderSummary();
  }

  function saveProfile(){
    var p=collect();
    if(!p.name){
      setTab("identity");
      document.getElementById("wl-name").focus();
      notify("Add your dog’s name first");
      return false;
    }
    var index=profiles.findIndex(function(item){return item.id===p.id});
    if(index>=0)profiles[index]=p;else profiles.push(p);
    selectedId=p.id;
    localStorage.setItem(SELECTED_KEY,selectedId);
    saveAll();
    renderStrip();
    renderSummary();
    notify(p.name+"’s profile saved");
    return true;
  }

  function newProfile(){
    selectedId=makeId();
    localStorage.setItem(SELECTED_KEY,selectedId);
    fill(null);
    renderStrip();
    renderSummary();
    setTab("identity");
    document.getElementById("wl-name").focus();
    notify("New dog profile ready");
  }

  function deleteProfile(){
    var p=selected();
    if(!p){notify("There is no saved dog to delete");return}
    if(!window.confirm("Delete "+(p.name||"this dog")+"’s profile?"))return;
    profiles=profiles.filter(function(item){return item.id!==p.id});
    saveAll();
    if(profiles.length)selectProfile(profiles[0].id);
    else{
      selectedId="";
      localStorage.removeItem(SELECTED_KEY);
      fill(null);renderStrip();renderSummary();
    }
    notify("Dog profile deleted");
  }

  function setTab(name){
    activeTab=name;
    tabs.forEach(function(t){t.classList.toggle("is-active",t.dataset.tab===name)});
    panels.forEach(function(p){p.classList.toggle("is-active",p.dataset.panel===name)});
    document.getElementById("wl-prev").disabled=order.indexOf(name)===0;
    document.getElementById("wl-next").disabled=order.indexOf(name)===order.length-1;
  }

  function moveTab(step){
    var i=order.indexOf(activeTab);
    setTab(order[Math.max(0,Math.min(order.length-1,i+step))]);
    root.scrollIntoView({behavior:"smooth",block:"start"});
  }

  function compressProfilePhoto(file){
    return new Promise(function(resolve,reject){
      var reader=new FileReader();

      reader.onerror=function(){
        reject(new Error("Could not read photo"));
      };

      reader.onload=function(){
        var image=new Image();

        image.onerror=function(){
          reject(new Error("Could not open photo"));
        };

        image.onload=function(){
          try{
            var maxSize=1200;
            var width=image.naturalWidth||image.width;
            var height=image.naturalHeight||image.height;

            if(!width||!height){
              resolve(String(reader.result||""));
              return;
            }

            var scale=Math.min(1,maxSize/Math.max(width,height));
            var targetWidth=Math.max(1,Math.round(width*scale));
            var targetHeight=Math.max(1,Math.round(height*scale));

            var canvas=document.createElement("canvas");
            canvas.width=targetWidth;
            canvas.height=targetHeight;

            var context=canvas.getContext("2d");
            if(!context){
              resolve(String(reader.result||""));
              return;
            }

            context.drawImage(image,0,0,targetWidth,targetHeight);

            var compressed=canvas.toDataURL("image/jpeg",0.82);
            resolve(compressed||String(reader.result||""));
          }catch(error){
            resolve(String(reader.result||""));
          }
        };

        image.src=String(reader.result||"");
      };

      reader.readAsDataURL(file);
    });
  }

  photoInput.addEventListener("change",function(e){
    var file=e.target.files&&e.target.files[0];
    if(!file)return;

    var type=String(file.type||"").toLowerCase();
    var name=String(file.name||"").toLowerCase();
    var looksLikeImage=
      type.indexOf("image/")===0||
      /\.(jpg|jpeg|png|webp|heic|heif)$/i.test(name);

    if(!looksLikeImage){
      notify("Choose a photo file");
      photoInput.value="";
      return;
    }

    notify("Preparing profile photo…");

    compressProfilePhoto(file)
      .then(function(result){
        if(!result)throw new Error("Empty photo");
        imageData=result;
        renderPhoto();
        notify("Profile photo added");
      })
      .catch(function(error){
        console.warn("WagLife profile photo error:",error);
        notify("That photo could not be added");
      })
      .finally(function(){
        photoInput.value="";
      });
  });

  form.addEventListener("submit",function(e){e.preventDefault();saveProfile()});
  document.getElementById("wl-save-top").addEventListener("click",saveProfile);
  document.getElementById("wl-add-dog").addEventListener("click",newProfile);
  document.getElementById("wl-delete").addEventListener("click",deleteProfile);
  document.getElementById("wl-prev").addEventListener("click",function(){moveTab(-1)});
  document.getElementById("wl-next").addEventListener("click",function(){moveTab(1)});

  tabs.forEach(function(tab){
    tab.addEventListener("click",function(){setTab(tab.dataset.tab)});
  });

  strip.addEventListener("click",function(e){
    var button=e.target.closest("[data-profile-id]");
    if(button)selectProfile(button.dataset.profileId);
  });

  if(profiles.length&&!selected())selectedId=profiles[0].id;
  if(selectedId)localStorage.setItem(SELECTED_KEY,selectedId);
  fill(selected());
  renderStrip();
  renderSummary();
  setTab("identity");
})();